import { render, staticRenderFns } from "./PremiumModal.vue?vue&type=template&id=6630ae4a&scoped=true"
import script from "./PremiumModal.vue?vue&type=script&lang=ts"
export * from "./PremiumModal.vue?vue&type=script&lang=ts"
import style0 from "./PremiumModal.vue?vue&type=style&index=0&id=6630ae4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6630ae4a",
  null
  
)

export default component.exports